import { extractCheckBoxValue } from "../store/form.answer.extract";

const checkBoxRequired = (answer, element) => {
  let value = extractCheckBoxValue(answer);
  if (value) {
    if (value.length > 0) {
      return true;
    }
  }
  return "This field is required.";
};

export { checkBoxRequired };
